import { render } from "./MerceariaUpload.vue?vue&type=template&id=9ddbc79e&scoped=true"
import script from "./MerceariaUpload.vue?vue&type=script&lang=js"
export * from "./MerceariaUpload.vue?vue&type=script&lang=js"

import "./MerceariaUpload.vue?vue&type=style&index=0&id=9ddbc79e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ddbc79e"]])

export default __exports__